/**
 * Terms of Service — public route. Required referenced from App Store metadata.
 */
export default function Terms() {
  return (
    <main className="max-w-3xl mx-auto px-6 py-10 prose prose-invert">
      <h1>Termos de Uso — Neural Core OS</h1>
      <p><strong>Última atualização:</strong> 24/04/2026</p>

      <h2>1. Aceitação</h2>
      <p>Ao usar o Neural Core OS você concorda com estes Termos. Se discorda, não use o app.</p>

      <h2>2. Conta</h2>
      <p>Você é responsável por suas credenciais e atividade. Notifique-nos sobre uso não autorizado em <a href="mailto:support@p2hm.app">support@p2hm.app</a>.</p>

      <h2>3. Uso aceitável</h2>
      <p>Não use para conteúdo ilegal, exploração de menores, malware, spam ou para enganar terceiros.</p>

      <h2>4. Conteúdo gerado por IA</h2>
      <p>Resultados de agentes IA são informativos, podem conter imprecisões e não substituem aconselhamento profissional (jurídico, médico, financeiro).</p>

      <h2>5. Compras e assinaturas</h2>
      <p>Pagamentos são processados pela App Store / Play Store. Cancelamento e reembolso seguem as políticas dessas lojas. Restaurar compras: Configurações → Assinaturas.</p>

      <h2>6. Propriedade intelectual</h2>
      <p>Você mantém a propriedade do seu conteúdo. Concede-nos licença mundial, não exclusiva, para processá-lo somente para operar o serviço.</p>

      <h2>7. Limitação de responsabilidade</h2>
      <p>Serviço fornecido "como está". Não garantimos disponibilidade ininterrupta. Limite máximo de responsabilidade = valor pago nos últimos 12 meses.</p>

      <h2>8. Encerramento</h2>
      <p>Podemos suspender contas que violem estes Termos. Você pode encerrar a qualquer momento via Configurações → Excluir Conta.</p>

      <h2>9. Lei aplicável</h2>
      <p>Brasil — foro de São Paulo/SP. (Atualize conforme país de operação.)</p>

      <h2>10. Contato</h2>
      <p><a href="mailto:support@p2hm.app">support@p2hm.app</a></p>
    </main>
  );
}
